import React from 'react';
import PropTypes from 'prop-types';
import { colorGray } from 'styles/layout/colors';

const IconSeatsXComfortably = ({
  color = colorGray,
  width = '48',
  height = '48',
  className = '',
}) => {
  <svg
    width={width}
    height={height}
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M17.1952 15.2651C19.2034 15.2651 20.8358 13.6327 20.8358 11.6246C20.8358 9.6181 19.2034 7.98401 17.1952 7.98401C15.1888 7.98401 13.5547 9.61642 13.5547 11.6246C13.5563 13.631 15.1887 15.2651 17.1952 15.2651ZM17.1952 9.24401C18.5077 9.24401 19.5758 10.3121 19.5758 11.6246C19.5758 12.9371 18.5077 14.0051 17.1952 14.0051C15.8827 14.0051 14.8147 12.9371 14.8147 11.6246C14.8163 10.3121 15.8827 9.24401 17.1952 9.24401V9.24401Z"
      fill={color}
    />
    <path
      d="M10.6236 39.5153H28.695C30.0649 39.5153 31.1985 38.4932 31.3806 37.1725L37.689 39.9616C37.7711 39.9977 37.858 40.0157 37.9433 40.0157C38.1796 40.0157 38.406 39.8828 38.5126 39.6564L40.0319 36.4588C40.168 36.1717 40.068 35.8272 39.8005 35.6565L31.4089 30.3326V23.7651C31.4089 23.4238 31.1382 23.1449 30.797 23.1351L22.4411 22.8955L20.4379 16.1608C20.346 15.8508 20.0327 15.6605 19.7144 15.7211L14.3102 16.7679L12.4777 11.5179C12.1495 10.5761 11.2571 9.94287 10.2596 9.94287C8.96347 9.94287 7.91016 10.9961 7.91016 12.2923V36.8014C7.91016 38.2976 9.12748 39.5149 10.6237 39.5149L10.6236 39.5153ZM38.6552 36.4211L37.6381 38.5621L31.4086 35.8091V31.8257L38.6552 36.4211ZM21.363 23.693C21.4401 23.9538 21.6764 24.136 21.9487 24.1425L30.1484 24.3771V26.9447H17.8583L14.728 17.9706L19.3938 17.0666L21.363 23.693ZM9.16999 12.2921C9.16999 11.6916 9.65891 11.2027 10.2594 11.2027C10.7221 11.2027 11.1355 11.4964 11.2881 11.9328L13.2831 17.6486C13.288 17.6682 13.2929 17.6863 13.2995 17.7043L16.8153 27.781C16.9039 28.0336 17.1418 28.2043 17.4109 28.2043H30.1486V36.8029C30.1486 37.6035 29.4957 38.2565 28.6951 38.2565L10.6237 38.2548C9.82312 38.2548 9.17014 37.6035 9.17014 36.8013L9.16999 12.2921Z"
      fill={color}
    />
  </svg>;
};

IconSeatsXComfortably.propTypes = {
  color: PropTypes.string,
  width: PropTypes.string,
  height: PropTypes.string,
  className: PropTypes.string,
};

export default IconSeatsXComfortably;
